import { render, staticRenderFns } from "./ListMain.vue?vue&type=template&id=7fac72e6&scoped=true"
import script from "./ListMain.vue?vue&type=script&lang=js"
export * from "./ListMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fac72e6",
  null
  
)

export default component.exports